export const news = {
  hero: {
    title: 'Nouvelles et histoires',
    subtitle: 'Restez informé de nos derniers rapports de terrain, histoires de réussite et annonces depuis le terrain en République démocratique du Congo',
  },
  featured: {
    badge: 'Histoire en vedette',
    fieldReporter: 'Journaliste de terrain',
    readFullStory: 'Lire l\'histoire complète',
  },
  categories: {
    all: 'Tout',
    fieldUpdates: 'Mises à jour du terrain',
    successStories: 'Histoires de réussite',
    announcements: 'Annonces',
  },
  card: {
    readMore: 'Lire la suite',
  },
  empty: {
    message: 'Aucun article trouvé dans cette catégorie',
  },
};
